require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_core-js@2.5.1@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 621
// module chunks = 0 1